exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.is-not-selected[data-v-59bcdfe6] {\n    opacity: 0.5;\n}\n#form-logo[data-v-59bcdfe6] {\n    height: 60px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n}\n@media (min-width: 768px) {\n#form-logo[data-v-59bcdfe6] {\n        height: 70px;\n        padding-top: 5px;\n        padding-bottom: 5px;\n}\n}\n@media (max-width: 768px) {\n.border-left[data-v-59bcdfe6] {\n        border: none !important;\n}\n}\n", ""]);

// exports
